export const formatCurrency = (value: string | number) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(+value / 100.0);
};
